import { render, staticRenderFns } from "./CanteenDeletion.vue?vue&type=template&id=795b2c9f&"
import script from "./CanteenDeletion.vue?vue&type=script&lang=js&"
export * from "./CanteenDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports